import { render, staticRenderFns } from "./InfrastrukturView.vue?vue&type=template&id=e5df3b4c&scoped=true"
import script from "./InfrastrukturView.vue?vue&type=script&lang=js"
export * from "./InfrastrukturView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5df3b4c",
  null
  
)

export default component.exports